// @flow

import { useState } from "react";
import { Button, CopyLink } from "./Button";

type HiddenPasswordProps = {
    password?: ?string;
}

export function HiddenPassword({ password }: HiddenPasswordProps) {
    const [show, setShow] = useState(false);

    return (
        <div className={'c-password'}>
            {show && password != null
                ? <CopyLink value={password}><span className='font-mono tracking-wider'>{password}</span></CopyLink>
                : <>•••••••••••••••</>
            }
            {password != null
                ? <Button size='xs' kind='bare' className='c-password--toggle' onClick={() => setShow(!show)}>{show ? 'Hide' : 'Show'}</Button>
                : null
            }
        </div>
    );
}